import { TicketsColumns } from "../Columns/TicketsColumns";
import { TicketsDurationColumns } from "../Columns/TicketsDurationColumns";
import CabinetItemsFilters from "./CabinetItemsFilters";
import TicketsDurationsSummaryFilters from "./TicketsDurationsSummaryFilters";
import TicketsFilters from "./TicketsFilters";
import { CabinetItemsColumns } from "../Columns/CabinetItemsColumns";
import TicketCallRecordsFilters from "./TicketCallRecordsFilters";
import { TicketCallRecordsColumns } from "../Columns/TicketCallRecordsColumns";
import MissedCallFilters from "./MissedCallFilters";
import { MissedCallColumns } from "../Columns/MissedCallColumns";
import StoreItemsMovementFilters from "./StoreItemsMovementFilters";
import { StoreItemsMovementColumns } from "../Columns/StoreItemsMovementColumns";
import EmployeeTicketReportFilters from "./EmployeeTicketsReportFilters";
import { EmployeeTicketReportColumns } from "../Columns/EmployeeTicketsReportColumns";

export const renderReportFilter = (reportName) => {
  switch (reportName) {
    case "departmentTicketsSummary":
      return {
        filter: <TicketsFilters />,
        columns: TicketsColumns,
      };
    case "ticketsDurationsSummary":
      return {
        filter: <TicketsDurationsSummaryFilters />,
        columns: TicketsDurationColumns,
      };
    case "cabinetItemsReport":
      return {
        filter: <CabinetItemsFilters />,
        columns: CabinetItemsColumns,
      };
    case "ticketRecordsReport":
      return {
        filter: <TicketCallRecordsFilters />,
        columns: TicketCallRecordsColumns,
      };
    case "missedCallReport":
      return {
        filter: <MissedCallFilters />,
        columns: MissedCallColumns,
      };
    case "storeMovementReport":
      return {
        filter: <StoreItemsMovementFilters />,
        columns: StoreItemsMovementColumns,
      };
    case "employeeTicketReport":
      return {
        filter: <EmployeeTicketReportFilters />,
        columns: EmployeeTicketReportColumns,
      };
    default:
      return {
        filter: <TicketsFilters />,
        columns: TicketsColumns,
      };
  }
};
